var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 689,
    height: 689,
    viewBox: "0 0 689 689",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.691 -12.3689C559.763 -25.5497 585.384 -15.0298 588.979 7.04749L694.204 653.219C697.975 676.375 674.902 694.703 653.199 685.792L19.0313 425.404C-2.67175 416.493 -6.20717 387.239 12.7481 373.414L541.691 -12.3689Z",
    fill: "#E9DDDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle1);
export default __webpack_public_path__ + "static/media/triangle1.d231e3aa9464e7b3626187fe37e4bacf.svg";
export { ForwardRef as ReactComponent };